import type { RouteRecordRaw } from 'vue-router'

/**
 * 官方站点路由配置
 *
 * 13个页面：
 * 1. home - 首页
 * 2. solutions - 解决方案
 * 3. products - 产品
 * 4. pricing - 定价
 * 5. about - 关于我们
 * 6. trial - 1元体验页
 * 7. login - 登录页
 * 8. payment/1yuan - 支付1元页
 * 9. report - 诊断报告页
 * 10. solution - 解决方案推荐页
 * 11. checkout - 套餐购买页
 * 12. payment/success - 支付成功页
 * 13. business/dashboard - 企业主平台
 *
 * 注意：1元免费诊断全链路（落地页 → 支付 → 表单 → 诊断中 → 报告 → 品牌确认）
 *   已迁移至 auto-site 路由 `/free-diagnosis/*`，避免被 OfficialPlatform Layout 壳包裹。
 *   PaymentOneYuan.vue 和 Report.vue 被两边路由共享引用。
 */
export const sannongRoutes: RouteRecordRaw[] = [
  {
    path: '/official-site',
    component: () => import('./OfficialPlatform.vue'),
    redirect: '/official-site/home',
    children: [
      {
        path: 'home',
        name: 'OfficialHome',
        component: () => import('./pages/Home.vue'),
        meta: {
          title: 'DeepTrust - 让您的品牌被AI看见',
          icon: 'home',
          permissions: ['*:official:*:view']
        }
      },
      {
        path: 'solutions',
        name: 'Solutions',
        component: () => import('./pages/Solutions.vue'),
        meta: {
          title: '解决方案 - DeepTrust',
          icon: 'solution',
          permissions: ['*:official:*:view']
        }
      },
      {
        path: 'products',
        name: 'Products',
        component: () => import('./pages/Products.vue'),
        meta: {
          title: '产品 - DeepTrust',
          icon: 'appstore',
          permissions: ['*:official:*:view']
        }
      },
      {
        path: 'pricing',
        name: 'Pricing',
        component: () => import('./pages/Pricing.vue'),
        meta: {
          title: '定价 - DeepTrust',
          icon: 'dollar',
          permissions: ['*:official:*:view']
        }
      },
      {
        path: 'about',
        name: 'About',
        component: () => import('./pages/About.vue'),
        meta: {
          title: '关于我们 - DeepTrust',
          icon: 'info-circle',
          permissions: ['*:official:*:view']
        }
      },
      {
        path: 'trial',
        name: 'Trial',
        component: () => import('./pages/Trial.vue'),
        meta: {
          title: '1元体验 - DeepTrust',
          icon: 'experiment',
          permissions: ['*:official:*:view']
        }
      },
      {
        path: 'login',
        name: 'Login',
        component: () => import('./pages/Login.vue'),
        meta: {
          title: '登录 - DeepTrust',
          icon: 'login',
          permissions: ['*:official:*:view']
        }
      },
      {
        path: 'payment/1yuan',
        name: 'PaymentOneYuan',
        component: () => import('./pages/PaymentOneYuan.vue'),
        meta: {
          title: '支付1元 - DeepTrust',
          icon: 'pay-circle',
          permissions: ['*:official:*:view']
        }
      },
      {
        path: 'report',
        name: 'Report',
        component: () => import('./pages/Report.vue'),
        meta: {
          title: '诊断报告 - DeepTrust',
          icon: 'file-text',
          permissions: ['*:official:*:view']
        }
      },
      {
        path: 'solution',
        name: 'Solution',
        component: () => import('./pages/Solution.vue'),
        meta: {
          title: '解决方案推荐 - DeepTrust',
          icon: 'bulb',
          permissions: ['*:official:*:view']
        }
      },
      {
        path: 'checkout',
        name: 'Checkout',
        component: () => import('./pages/Checkout.vue'),
        meta: {
          title: '购买套餐 - DeepTrust',
          icon: 'shopping-cart',
          permissions: ['*:official:*:view']
        }
      },
      {
        path: 'payment/success',
        name: 'PaymentSuccess',
        component: () => import('./pages/PaymentSuccess.vue'),
        meta: {
          title: '支付成功 - DeepTrust',
          icon: 'check-circle',
          permissions: ['*:official:*:view']
        }
      },
      {
        path: 'business/dashboard',
        name: 'OfficialBusinessDashboard',
        component: () => import('./pages/BusinessDashboard.vue'),
        meta: {
          title: '企业主投喂GEO后台 - DeepTrust',
          icon: 'dashboard',
          permissions: ['*:official:*:view']
        }
      }
    ]
  }
]

export default sannongRoutes
